module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn common",
    class: [_vm.isActive ? 'toogle-primary' : 'toogle-secondary'],
    attrs: {
      "id": [_vm.idLeft],
      "type": "'button'"
    },
    on: {
      "click": function () { return _vm.trackEvent('idLeft'); }
    }
  }, [(_vm.labelLeft) ? _c('span', [_vm._v(_vm._s(_vm.labelLeft))]) : _vm._e()]), _c('button', {
    staticClass: "btn common",
    class: [_vm.isActive ? 'toogle-secondary' : 'toogle-primary'],
    attrs: {
      "id": [_vm.idRight],
      "type": "'button'"
    },
    on: {
      "click": function () { return _vm.trackEvent('idRight'); }
    }
  }, [(_vm.labelRight) ? _c('span', [_vm._v(_vm._s(_vm.labelRight))]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-db7bdbc6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db7bdbc6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/buttons/toogle/toogle.pug
// module id = 1460
// module chunks = 0